import {
  FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_REQUEST,
  FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_SUCCESS,
  FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_FALUIRE,
} from './deleteProjectTemplateTaskLaneTypes'

const initialState = {
  loading: false,
  deleteProjectTemplateTaskLane: null,
  error: '',
}

const reducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_SUCCESS : return {
      ...state,
      deleteProjectTemplateTaskLane: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_DELETE_PROJECT_TEMPLATE_TASK_LANE_FALUIRE : return {
      ...state,
      loading: false,
      deleteProjectTemplateTaskLane: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
